import { Component, OnInit, ViewChild, inject } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

// import {
//   SocialAuthService,
//   GoogleLoginProvider
// } from '@abacritt/angularx-social-login';
import { APIServiceService } from './api/apiservice.service';
import { UserAuthService } from './auth/user-auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { LocationStrategy, PlatformLocation } from '@angular/common';

import { environment } from '../environments/environment';
import { Auth } from '@angular/fire/auth';
import { NotificationsService } from './services/notifications.service';
import { AppointmentEditSlideoverComponent } from './views/appointment-edit-slideover/appointment-edit-slideover.component';
import { AppointmentEditorService } from './services/appointment-editor.service';
import { RSFirebaseService } from './services/rsfirebase.service';


@Component({
  selector: 'ubc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private auth = inject(Auth)
  title = 'RSSaddlesBookingSystem';
  user;
  loggedIn;

  @ViewChild('appointmentEditSlideover', {}) private appointmentEditSlideover: AppointmentEditSlideoverComponent

  constructor(
    // private socialAuthService: SocialAuthService,
    private apiService: APIServiceService,
    public userAuthService: UserAuthService,
    private router: Router,
    public notificationsService: NotificationsService,
    public appointmentEditorService: AppointmentEditorService,
    public rsFirebaseService: RSFirebaseService
    ) {}

  calenderPlugins = [dayGridPlugin, timeGridPlugin, interactionPlugin];
  ngOnInit() {

    this.appointmentEditorService.registerComponent(this)

    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0);
    });
}

  signInWithGoogle(): void {
    // const socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    // this.socialAuthService.signIn(socialPlatformProvider).then(
    //   (userData) => {
    //     this.apiService.user.login(userData.idToken)
    //     .then((user) => {

    //     })
    //     .catch((err) => {
    //     })

    //   }
    // );
  }

  signOut(): void {
   // this.socialAuthService.signOut();
  }

  getAppointmentEditor(): AppointmentEditSlideoverComponent {
    return this.appointmentEditSlideover
  }

  



}
